import React, { useRef, useEffect } from 'react';
import style from './home.module.scss';
import Icon from '@components/icon-component';
import { Link } from 'react-router-dom';

const UpdateAppInfo = ({ setClosedNotifications, isVisible, setIsVisible }) => {
  const updateTimerRef = useRef(null);

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (updateTimerRef.current) {
        clearTimeout(updateTimerRef.current);
      }
    };
  }, []);
  return (
    <>
      <div className={`${style.infoAboutVersion} ${!isVisible ? style.closed : ''} `}>
        <p>
          Good stuff! You’ve got the latest version of Oplii Mobile. See what’s new{' '}
          <Link to={'/help?selectedSetting=Updates&NewVersion=true'} className={style.link}>
            here
          </Link>{' '}
          .
        </p>
        <p
          className={style.icon}
          onClick={() => {
            setIsVisible(false);
            if (updateTimerRef.current) {
              clearTimeout(updateTimerRef.current);
            }
            updateTimerRef.current = setTimeout(() => {
              localStorage.setItem('isUpdatingAppComplete', false);
              setClosedNotifications(false);
              const onlineOfflineIndicator = document.getElementById('onlineOfflineIndicator');
              if (onlineOfflineIndicator) {
                onlineOfflineIndicator.classList.remove('onlineOfflineIndicatorOnUpdateApp');
              }
            }, 500);
          }}
        >
          <Icon name={'closed-icon-white'} />
        </p>
      </div>
    </>
  );
};

export default UpdateAppInfo;
